import React, { memo, useCallback, useState } from "react";
import Reset from "../../icons/Reset";
import styles from "./ResetBlock.module.scss";

import shallow from "zustand/shallow";
import CustomModal from "../../Modals/CustomModal/CustomModal";
import { Button, Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";
import { useShelvingStore, useStoreRoom, useStoreSystem } from "../../../store";
import { useCurrentSearchParam } from "../../../utils/hooks/useCurrentSearchParam";

const ResetBlock = memo(() => {
    const [isOpenResetModal, setIsOpenResetModal] = useState<boolean>(false);
    const [, setNewHash] = useCurrentSearchParam("hash");

    //Настройки сброса стейта
    const [withFilling, setWithFilling] = useState<boolean>(true); //С наполнением
    const [withDecors, setWithDecors] = useState<boolean>(false); //C интерьером
    const [withRoom, setWithRoom] = useState<boolean>(false); //С комнатой
    const { proMode } = useStoreSystem(
        (state) => ({
            proMode: state.proMode,
        }),
        shallow
    );
    const { resetShelvingStore } = useShelvingStore(
        (state) => ({ resetShelvingStore: state.resetShelvingStore }),
        shallow
    );
    const { resetRoomStore } = useStoreRoom((state) => ({ resetRoomStore: state.resetRoomStore }), shallow);
    const { setWallZoomTarget } = useStoreSystem((state) => ({ setWallZoomTarget: state.setWallZoomTarget }), shallow);
    const { setSystemProperties } = useStoreSystem(
        (state) => ({ setSystemProperties: state.setSystemProperties }),
        shallow
    );

    const openResetModal = useCallback(() => {
        setIsOpenResetModal(true);
    }, []);

    const onCloseResetModal = useCallback(() => {
        setIsOpenResetModal(false);
    }, []);

    const onResetStoreInModal = useCallback(() => {
        setNewHash("");
        resetShelvingStore(withFilling, withRoom);
        resetRoomStore(withDecors, withRoom);
        if (withRoom || withFilling) {
            //Двигаем камеру, если поменяли размер помещения или удалили наполнение
            setWallZoomTarget();
        }
        if (withRoom && withFilling && withDecors && proMode) {
            setSystemProperties([{ name: "proMode", value: false }]);
            setSystemProperties([{ name: "proModeEverActivated", value: false }]);
        }
        setIsOpenResetModal(false);
    }, [
        setNewHash,
        resetShelvingStore,
        withFilling,
        withRoom,
        resetRoomStore,
        withDecors,
        proMode,
        setWallZoomTarget,
        setSystemProperties,
    ]);

    return (
        <div className={styles.container}>
            <div onClick={openResetModal} className={styles.resetButton}>
                <Reset />
            </div>
            <span onClick={openResetModal} className={styles.reset}>
                Сброс
            </span>
            {isOpenResetModal && (
                <CustomModal isOpenModal={isOpenResetModal} onCloseModalCallback={onCloseResetModal}>
                    <div className={styles.resetModal}>
                        <div className={styles.text}>Вы действительно хотите очистить проект?</div>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={withFilling}
                                        onChange={() => setWithFilling(!withFilling)}
                                        sx={{
                                            color: "#EB3D00",
                                            "&.Mui-checked": {
                                                color: "#EB3D00",
                                            },
                                        }}
                                    />
                                }
                                label={<Typography>С наполнением</Typography>}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={withDecors}
                                        onChange={() => setWithDecors(!withDecors)}
                                        sx={{
                                            color: "#EB3D00",
                                            "&.Mui-checked": {
                                                color: "#EB3D00",
                                            },
                                        }}
                                    />
                                }
                                label={<Typography>С интерьером</Typography>}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={withRoom}
                                        onChange={() => setWithRoom(!withRoom)}
                                        sx={{
                                            color: "#EB3D00",
                                            "&.Mui-checked": {
                                                color: "#EB3D00",
                                            },
                                        }}
                                    />
                                }
                                label={<Typography>С комнатой</Typography>}
                            />
                        </FormGroup>
                        <div className={styles.buttons}>
                            <Button
                                onClick={onResetStoreInModal}
                                sx={{ mr: 1 }}
                                variant={"contained"}
                                color={"primary"}
                            >
                                Да
                            </Button>
                            <Button onClick={onCloseResetModal} variant={"contained"} color={"primary"}>
                                Отмена
                            </Button>
                        </div>
                    </div>
                </CustomModal>
            )}
        </div>
    );
});

export default ResetBlock;
